module.exports = __webpack_public_path__ + "static/media/reviews-fill.3ada1b63.svg";